export default __webpack_public_path__ + "static/media/kaus-phones.6ad09ad9.png";